export default __webpack_public_path__ + "static/media/TheElements _15.167be3ce.png";